/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Label from "../Label";
import { useController } from "react-hook-form";
import { StyledFormField } from "./StyledFormField";
import { useTranslate } from "../../../hooks/useTranslate";

const InputWrapper = styled.div`
  position: relative;
`;

const InputPrefix = styled.span`
  position: absolute;
  left: 8px;
  top: 50%;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.875);
  transform: translateY(-50%);
  color: rgba(${({ theme }) => theme.colors.text.rgba});
`;

const NumberField = ({
  name,
  control,
  label,
  required = false,
  defaultValue,
  validationRules = {},
  prefix,
  placeholder,
  ...props
}) => {
  const { _t } = useTranslate();
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      required: required ? "error_value_is_empty" : undefined,
      ...validationRules,
    },
    defaultValue: defaultValue || "",
  });

  return (
    <>
      {label ? (
        <Label name={name} required={required}>
          {label}
        </Label>
      ) : undefined}
      <InputWrapper>
        {prefix && <InputPrefix>{prefix}</InputPrefix>}
        <StyledFormField.Input
          {...field}
          id={name}
          type="number"
          $hasPrefix={prefix}
          $error={fieldState.error}
          aria-invalid={!!fieldState.error}
          aria-required={required || undefined}
          aria-describedby={fieldState.error ? `${name}-error` : undefined}
          placeholder={_t(placeholder)}
          {...props}
        />
      </InputWrapper>
    </>
  );
};

export default NumberField;
